import { BasketErrorModel } from 'models/Errors';
import { logsHelper, userHelper, generateRandomId, getHostName } from 'helpers';
import { basketStorage } from 'storages';
import { appConfig } from 'configurations';
import { logsHttp } from './http';

const MAX_STACK_LENGTH = 300;
const MAX_SOURCE_LENGTH = 300;

export class LogsRepository {
    public async sendErrorMessage(error: Error | BasketErrorModel): Promise<void> {
        try {
            const userName = userHelper.getCurrentUserName() ?? 'anonymous';

            const messageObject = {
                currentBasketId: basketStorage.getBasket()?.guid ?? null,
                error: error instanceof BasketErrorModel ? this.formatBasketError(error) : this.formatNativeError(error),
                page: window.location.href,
                userName
            };

            const message = JSON.stringify(messageObject);
            const url = logsHelper.getLogEndpoint(messageObject);

            if (appConfig.enableErrorLogging) {
                await this.sendMessage(url, message, userName);
            }
        } catch (loggingError) {
            // eslint-disable-next-line no-console
            console.error(loggingError);
        }
    }

    private formatBasketError(error: BasketErrorModel | Error): any {
        if (error instanceof BasketErrorModel) {
            error.stack = error.stack ? error.stack.substring(0, MAX_STACK_LENGTH) : error.stack;
            error.source = error.source ? error.source.substring(0, MAX_SOURCE_LENGTH) : error.source;

            let innerError = null;
            if (error.innerError) {
                innerError = this.formatBasketError(error.innerError);
            }

            return {
                message: error.message,
                stack: error.stack,
                innerError: innerError,
                logMessage: error.logMessage,
                source: error.source,
                data: error.data
            };
        }

        return this.formatNativeError(error);
    }

    private formatNativeError(error: Error): any {
        return {
            message: error.message,
            stack: error.stack
        };
    }

    private async sendMessage(url: string, message: any, userName: string): Promise<void> {
        try {
            await logsHttp.post(url,
                {
                    hostName: getHostName(),
                    pageId: 0,
                    sessionId: this.getSessionId(),
                    userName,
                    message
                }
            );
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(error);
        }
    }

    private getSessionId(): string {
        let logSessionId = userHelper.getLogSessionId();

        if (!logSessionId) {
            logSessionId = generateRandomId();
            userHelper.saveLogSessionId(logSessionId);
        }

        return logSessionId;
    }
}

export const logs = new LogsRepository();